import {
  type EdgeData,
  type NodeSn,
  type SnapshotId,
  isPathLookupEdgeData,
  isTopologyEdgeData,
} from '@ipfabric/utils';
import { labelsToStringArray } from 'components/Graph/GraphApp/GraphEdge';
import type { GraphData } from 'components/Graph/model/GraphData';
import type { DeviceExplorerEdgeData } from '../deviceViewTypes';
import { getEdgeCompareMode } from './getEdgeCompareMode';

export const getDeviceExplorerEdgeData = (
  edgeData: EdgeData,
  graphData: GraphData,
  sourceSn: NodeSn | null,
  targetSn: NodeSn | null,
  snapshotToCompareId: SnapshotId | null,
): DeviceExplorerEdgeData => ({
  color: edgeData.style?.line?.color,
  compareMode: getEdgeCompareMode(edgeData, snapshotToCompareId),
  children: isTopologyEdgeData(edgeData) ? edgeData.children : [edgeData.id],
  edgeDirection: edgeData.direction,
  intentCheckResult: edgeData.intentCheckResult,
  labels: labelsToStringArray(edgeData.labels),
  protocol: edgeData.protocol,
  sourceIfaceName: isPathLookupEdgeData(edgeData)
    ? (edgeData.sourceIfaceName ?? null)
    : null,
  sourceLabel: graphData.nodes[edgeData.source]?.label ?? null,
  sourceType: graphData.nodes[edgeData.source]?.type ?? null,
  sourceSn,
  targetIfaceName: isPathLookupEdgeData(edgeData)
    ? (edgeData.targetIfaceName ?? null)
    : null,
  targetSn,
  targetLabel: graphData.nodes[edgeData.target]?.label ?? null,
  targetType: graphData.nodes[edgeData.target]?.type ?? null,
});
